import colors from "../../../constants/colors";

const styles = (theme) => {
  return {
    box: {
      marginLeft: "5%",
      marginRight: "5%",
    },
    buttonBox: {
      margin: "5%",
    },
    emailBox: {
      marginLeft: "2%",
      marginRight: "2%",
    },
    label: {
      "white-space": "nowrap",
      [theme.breakpoints.down("sm")]: {
        fontSize: 13,
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: 15,
      },
    },
    error: {
      color: colors.htmlRed,
      "font-weight": "bold",
      "font-family": "Montserrat",
    },
  };
};

export default styles;
